import React, { useState } from 'react';
import { Card } from '../../components/ui/Card';
import { Play, Loader2 } from 'lucide-react';

export default function IkasSandbox() {
  const [endpoint, setEndpoint] = useState('/api/ikas/raw');
  const [params, setParams] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const runQuery = async () => {
    setLoading(true);
    setError(null);
    setResult(null);
    try {
      const qs = params.trim() ? '?' + params.trim() : '';
      const res = await fetch(endpoint + qs);
      const data = await res.json();
      setResult(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: 24, maxWidth: 1400, margin: '0 auto' }}>
      <h1 style={{ fontSize: 24, fontWeight: 700, marginBottom: 16 }}>Ikas Sandbox</h1>

      <Card style={{ padding: 20, marginBottom: 20 }}>
        <div style={{ display: 'flex', gap: 12, alignItems: 'flex-end', flexWrap: 'wrap' }}>
          <div style={{ flex: '0 0 360px' }}>
            <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 4 }}>Endpoint</label>
            <input
              value={endpoint}
              onChange={(e) => setEndpoint(e.target.value)}
              style={{
                width: '100%', padding: '8px 12px', borderRadius: 8,
                border: '1px solid #d1d5db', fontSize: 14, fontFamily: 'monospace'
              }}
            />
          </div>
          <div style={{ flex: 1, minWidth: 200 }}>
            <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 4 }}>
              Query Params <span style={{ fontWeight: 400, color: '#6b7280' }}>(key=val&key2=val2)</span>
            </label>
            <input
              value={params}
              onChange={(e) => setParams(e.target.value)}
              placeholder="startDate=2026-02-01&endDate=2026-02-16"
              style={{
                width: '100%', padding: '8px 12px', borderRadius: 8,
                border: '1px solid #d1d5db', fontSize: 14, fontFamily: 'monospace'
              }}
            />
          </div>
          <button
            onClick={runQuery}
            disabled={loading}
            style={{
              display: 'flex', alignItems: 'center', gap: 6,
              padding: '8px 20px', borderRadius: 8, border: 'none',
              background: '#6366f1', color: '#fff', fontWeight: 600,
              fontSize: 14, cursor: loading ? 'wait' : 'pointer'
            }}
          >
            {loading ? <Loader2 size={16} className="animate-spin" /> : <Play size={16} />}
            {loading ? 'Yükleniyor...' : 'Çalıştır'}
          </button>
        </div>
      </Card>

      {error && (
        <Card style={{ padding: 16, marginBottom: 20, background: '#fef2f2', border: '1px solid #fca5a5' }}>
          <pre style={{ color: '#dc2626', margin: 0, fontSize: 13 }}>{error}</pre>
        </Card>
      )}

      {result && (
        <Card style={{ padding: 20 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 12 }}>
            <span style={{ fontSize: 14, fontWeight: 600 }}>
              Sonuç {Array.isArray(result) ? `(${result.length} satır)` : ''}
            </span>
          </div>
          <pre style={{
            background: '#f9fafb', padding: 16, borderRadius: 8,
            fontSize: 12, fontFamily: 'monospace', overflow: 'auto',
            maxHeight: 600, whiteSpace: 'pre-wrap', wordBreak: 'break-word'
          }}>
            {JSON.stringify(result, null, 2)}
          </pre>
        </Card>
      )}
    </div>
  );
}
